import './Locations.css';

function Wilderness() {
  return (
    <div className="Wilderness">
      <h3>Mt. Rose Wilderness</h3>
      <p>
      In the summer, Kore told Cyane she wanted to conquer the world. Or, perhaps, not the world, but nature; 
      she wanted to return to the wilderness and forget about algebra and grammar and history. Leave mortal 
      necessities behind to become one with the greater beings. An easy task with the woods and Toiyabe National Forest as a backyard.
      </p>
      <p>
      Each day at dawn, they met at the hidden entrance to the Mt. Rose Wilderness, backpacks full of nuts 
      and apples and sandwiches and water. Cyane had bear spray in the left pocket of her cargo shorts and 
      had rummaged through hiking gear at home to find two pairs of bells to attach to her and Kore’s bags.
      </p>
      <p>
      Then, while the moon was still hanging palely in the sky and as the sun was just about to peek over 
      the sides of the eastern mountains surrounding the Tahoe basin, the two would set off on the trail, 
      their bells and the calls of tanagers and Stellar’s Jays the only noise. The first hour was a long 
      climb in elevation, they would walk up the mountain through the morning fog, steep zig zags crossing 
      back and forth through tall pine trees, their boots kicking up small clouds of dust.
      </p>
      <p>
      The elevation robbed air and speech from their bodies, and lingering aches of sleep and previous hikes 
      poked and prodded them, but still, they rose up the mountain with the sun.
      </p>
      <p>
      After a particularly steep section, Kore breathlessly motions for Cyane to join her. Wordlessly, they 
      pick through fallen branches and low-lying bushes off-trail until they reach their favorite spot for 
      breakfast. The trees clear slightly at a short cliff overlooking the Tahoe basin:  a blue jewel 
      surrounded by emerald forests and diamond-like snow on the distant mountains. They silently bite into 
      apples, munching softly as they look out onto their dominion. Cyane can feel unbridled energy begin to 
      overtake the soreness in her body; excitement for the unknown. She feels it buzzing from Kore as well, 
      a deep and primal urge to dive further into the mountain’s embrace.
      </p>
      <p>
      “You ready?”
      </p>
      <p>
      “You ready?”
      </p>
      <p>
      They race each other back to the trail, laughing, waking the wind, and sending birds flapping. A 
      breeze dances around them as they surge up the trail, its invisible limbs tousling their hair and 
      playing with the bells jingling on their bags, then leaping like a cat from branch to branch above their heads.
      </p>
      <p>
      Cyane and Kore forget about gravity, flying alongside Third Creek as it snakes up the hill, up and 
      up until there is stubborn snow that clings angrily to the mountainside in defiance of the sun’s heat. 
      They pause here, catching their breath and inhaling the sharp scent of iced pine and wet dirt. The wind 
      divides, chasing smaller versions of itself around the snowed-in glade, stirring up shimmering powder in 
      little whirlwinds before scampering up and around the trees like little squirrels. Its movement shakes 
      the pine branches up above, making the trees sigh with pleasure.
      </p>
      <p>
      Slowly, savoring the crisp sound of boots breaking through snow crust, Cyane and Kore follow the wind up 
      what they hope is the trail. The wind leads them to a small hill, where an old fire road snakes further 
      up the mountain. To the left, atop a ridge, they can see the old Relay Peak radio tower; up ahead, the tip 
      of Mt. Rose’s peak, and to the right, the wide ribbons of dirt cutting through dense forest, indicating 
      the Mt. Rose ski resort. Behind them, Lake Tahoe gleams.
      </p>
      <p>
      Most days, Kore and Cyane would go left toward Relay Peak. There was a little pond they affectionately 
      deemed “Frog Pond” where they would sometimes stop for a few hours, entranced by the choir performance 
      of said amphibians. The wind, forever impatient, would meander up into the atmosphere, allowing Kore and 
      Cyane a moment alone. Lying in the thick grass surrounding the pond, listening to the frogs, they would 
      fall asleep, awakening again under a sky glittering with stars. Kore would point out the faint white mist 
      of the Milky Way, or trace out Orion and Sirius. Cyane would be watching the version of the night sky 
      reflected in Kore’s eyes. If you are falling for long enough, there is a moment where you no longer realize 
      you are falling and you think you are flying.
      </p>
      <p>
      Today, Cyane and Kore went to Mt. Rose. An extra long hike, but it was nearing the end of summer and 
      Kore said she wanted to go before… something. Cyane realized Kore had never actually said what would 
      be after the hike but assumed it was school. Hoped it was school.      </p>
      <p>
      With the wind for company, the two girls clamber up the mountainside. By now not even the toughest snow 
      hiding in the deepest recesses of shade had survived the heat of summer, and the usually strong wind fell 
      behind to stay at the tree line, leaving Kore and Cyane to cook in the unrelenting heat of the naked mountainside. 
      </p>
      <p>
      Up and up and up, and just when Cyane thought the hike was over there was more up. Today there was a heaviness 
      in the air; besides the lack of wind, the usual crackle of energy around Kore felt like it was fizzling. Even 
      at the top of the mountain (when they finally made it) Kore seemed more upset.
      </p>
      <p>
      “Kore, vibes have been way off this whole hike. What’s up?”
      </p>
      <p>
      “I… I don’t know when a good time to tell you this is. Maybe I should have told you earlier, or maybe 
      I should wait until after the hike, ugh. I don’t know.”
      </p>
      <p>
      There is a silence that tumbles onto the mountain, a hush deep and desperate and lonely.
      </p>
      <p>
      “What are you talking about?” Cyane asks cautiously, stepping toward Kore and grasping her hands.
      </p>
      <p>
      “I’m moving. Leaving. I’ve known about it since the end of school but I was scared to tell you and hoping that 
      it was just a bad dream but I only have a day left in Tahoe and then I’m gone.”
      </p>
      <p>A tether connecting Cyane’s center and soul to the earth tugs sharply, bringing her abruptly to her knees. <i>Please don’t ever leave me. I think I love you. </i>
      A splintering in her abdomen, like someone was breaking a piece of ice or crushing a rock. She would be gone?
      </p>
      <p>
      “Moving! Where? Why didn’t you tell me sooner? How could you know this whole time and not tell me?” 
      </p>
      <p>
      What little air had been at the top of the mountain dissipated, and Cyane gasps helplessly like a fish out of 
      water. Open and close the mouth, lungs moving desperately to try and pump air in and out, but there’s nothing. She would be gone.
      </p>
      <p>
      “It isn’t like I’m dying, we will still talk every day and of course I’m going to come visit you and you’ll 
      come visit me and we can look back at what a good summer this was.”
      </p>
      <p>
        <i>Not like she’s dying. But I feel like I am.</i>
        The trees below them begin to moan as the wind gains energy to move through them, carrying the lament up 
        the mountain. Cyane wants to join as pain blossoms along her sternum like her heart was clawing at her throat trying to jump out and into Kore’s waiting hands.
        <i>I would cut out my heart and give it to Kore.</i>
      </p>
      <p>
      But her eyes stay stubbornly dry. Even as Kore weeps into her shoulder, even as they make their way back down 
      the mountain—Kore carefully and Cyane with careless abandon, even as they exit the Mt. Rose Wilderness, even 
      as they go to their separate homes, even as Kore boards the plane that night and Cyane goes to sleep, even 
      the next morning as Cyane goes back to the entrance and waits while the sun rises and peaks and then sets, 
      even as Cyane continues to return and sit there each day for the rest of the summer, even as school starts 
      again and Kore isn’t there, even as fall becomes Uller Fest and Kore isn’t there, even as early winter turns 
      into Nutcracker season and Kore isn’t there, even as life continues on and Kore isn’t there and Cyane’s heart 
      breaks over and over again at the thought of her not by her side, even then, her eyes stay stubbornly dry. And she hates it.
      </p>
    </div>
  );
}

export default Wilderness;
